export class FileSelectState {
    public constructor(private readonly window: Window, private readonly inputId = 'global-file-select') {}

    public select(multiple = false, timeout = 2000, directory = false): Promise<File[]> {
        const request = this.createRequest()
        this.runRequest(request, multiple, timeout, directory)
        return request.done
    }

    private runRequest(req: SelectRequest, multiple: boolean, timeout: number, directory: boolean) {
        const input = this.getFileInput(multiple, directory)
        const window = this.window

        window.document.body.onfocus = function onDocFocus() {
            setTimeout(() => {
                req.resolve([])
            }, timeout)
            window.document.body.onfocus = null
        }

        input.onchange = function () {
            req.resolve(Array.from(input.files || []))
        }

        input.click()
    }

    private getFileInput(multiple: boolean, directory: boolean): HTMLInputElement {
        const ipt = this.window.document.createElement('input')
        ipt.type = 'file'
        ipt.id = this.inputId
        if (multiple) {
            ipt.multiple = true
        }
        if (directory) {
            ipt.webkitdirectory = true
        }
        return ipt
    }

    private createRequest(): SelectRequest {
        let resolve: SelectRequest['resolve'] | undefined
        let reject: SelectRequest['reject'] | undefined
        const done = new Promise<File[]>((res, rej) => {
            resolve = res
            reject = rej
        })

        if (!resolve || !reject) {
            throw new Error('Invariant failed: promise constructor did not run synchronously')
        }

        return {resolve, reject, done}
    }
}

interface SelectRequest {
    done: Promise<File[]>
    resolve(files: File[]): void
    reject(err: any): void
}
